import styled from "styled-components";

export const RootContainer = styled.div`
  height: 100vh;

  .infinite-scroll-component__outerdiv {
    height: calc(100vh - 70px);
  }

  .infinite-scroll-component {
    height: 100% !important;
    overflow-x: hidden !important;
  }
`;

export const HistoryContainer = styled.div`
  width: 100%;
  gap: 4px;
`

export const HistoryBox = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px 16px;
  gap: 4px;
  background-color: #f7f7f7;
  margin-bottom: 1px;
`

export const DateAndAmountContainer = styled.div`
  display: flex;
  flex-direction: row;
`
export const Date = styled.p`
  flex-grow: 1;
  color: #2B2B2B;
  font-family: Plus Jakarta Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-align: left;
`
export const Amount = styled.p`
  color: #C21C05;
  text-align: right;
  font-family: Plus Jakarta Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`

export const Time = styled.p`
  color: #808080;
  font-family: Plus Jakarta Sans;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`

export const ExpireBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  gap: 4px;
`

export const ExpireText = styled.p`
  color: #D93B0C;
  font-family: Plus Jakarta Sans;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`

export const ExpiredTime = styled.p`
  color: #808080;
  font-family: Plus Jakarta Sans;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`

export const SpinWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${props => props.size === 'large' ? 'calc(100vh - 70px)' : 'auto'};
`;

export const EmptyText = styled.div`
height: calc(100vh - 70px);
align-items: center;
justify-content: center;
display: flex;
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: normal;
color: #808080;
`;
